import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface VideoModalProps {
  videoUrl: string;
  onClose: () => void;
}
const VideoModal: React.FC<VideoModalProps> = ({
  videoUrl,
  onClose
}) => {
  const getEmbedUrl = (url: string) => {
    // YouTube
    if (url.includes('youtube.com') || url.includes('youtu.be')) {
      const videoId = url.includes('youtu.be') ? url.split('youtu.be/')[1]?.split('?')[0] : url.split('v=')[1]?.split('&')[0];
      return `https://www.youtube.com/embed/${videoId}?autoplay=1`;
    }
    // Vimeo
    if (url.includes('vimeo.com')) {
      const videoId = url.split('vimeo.com/')[1]?.split('?')[0];
      return `https://player.vimeo.com/video/${videoId}?autoplay=1`;
    }
    // Direct video URL
    return url;
  };
  const embedUrl = getEmbedUrl(videoUrl);
  const isDirectVideo = !videoUrl.includes('youtube') && !videoUrl.includes('vimeo');
  return <>
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center p-4" onClick={onClose} data-id="element-2521">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.95
      }} transition={{
        duration: 0.2
      }} className="relative w-full max-w-5xl bg-surface-elevated rounded-2xl shadow-2xl overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-2522">
          {/* Header */}
          <div className="flex items-center justify-between p-4 border-b border-custom bg-surface" data-id="element-2523">
            <h3 className="text-lg font-semibold text-text-primary" data-id="element-2524">
              Quick Tour
            </h3>
            <button onClick={onClose} className="p-2 rounded-lg hover:bg-surface-elevated transition-colors" aria-label="Close video" data-id="element-2525">
              <XIcon size={20} className="text-text-secondary" data-id="element-2526" />
            </button>
          </div>
          {/* Video Content */}
          <div className="relative bg-black" style={{
          paddingBottom: '56.25%'
        }} data-id="element-2527">
            {isDirectVideo ? <video className="absolute inset-0 w-full h-full" controls autoPlay src={embedUrl} data-id="element-2528">
                Your browser does not support the video tag.
              </video> : <iframe className="absolute inset-0 w-full h-full" src={embedUrl} title="Product Tour Video" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-2529" />}
          </div>
        </motion.div>
      </motion.div>
    </>;
};
export default VideoModal;